import { render, staticRenderFns } from "./EditSlider.vue?vue&type=template&id=464c1126"
import script from "./EditSlider.vue?vue&type=script&lang=js"
export * from "./EditSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports